/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './font.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/font/font.component';
const styles_FontComponent:any[] = [i0.styles];
export const RenderType_FontComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_FontComponent,data:{}});
export function View_FontComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(278528,
      (null as any),0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngClass:[0,'ngClass']},(null as any))],(_ck,_v) => {
    var _co:i3.FontComponent = _v.component;
    const currVal_0:any = _co.classes;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_FontComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-font',([] as any[]),
      (null as any),(null as any),(null as any),View_FontComponent_0,RenderType_FontComponent)),
      i1.ɵdid(573440,(null as any),0,i3.FontComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const FontComponentNgFactory:i1.ComponentFactory<i3.FontComponent> = i1.ɵccf('admin-font',
    i3.FontComponent,View_FontComponent_Host_0,{name:'name',color:'color'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2ZvbnQvZm9udC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvZm9udC9mb250LmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2ZvbnQvZm9udC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2ZvbnQvZm9udC5jb21wb25lbnQudHMuRm9udENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxzcGFuIFtuZ0NsYXNzXT1cImNsYXNzZXNcIj48L3NwYW4+IiwiPGFkbWluLWZvbnQ+PC9hZG1pbi1mb250PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSwrRUFBQTtNQUFBO3FCQUFBOztJQUFNO0lBQU4sV0FBTSxTQUFOOzs7O29CQ0FBO01BQUE7YUFBQTtVQUFBOzs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/font/font.component.ngfactory.ts